import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import { PaginationBaseModel } from '../../models';
import { paginationItemsOnPage } from './constants/pagination';

interface CustomPaginationProps extends PaginationBaseModel {
  onChange?: (newPage: number) => void;
  onChangeRowsPerPage?: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  >;
  disabled?: boolean;
}

export function CustomPagination({
  total,
  page,
  perPage,
  onChange,
  onChangeRowsPerPage,
}: CustomPaginationProps) {
  const onPageChange = (e, newPage) => {
    onChange(newPage);
  };

  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={[
        ...paginationItemsOnPage,
        { label: 'All', value: total },
      ]}
      count={total && perPage ? Math.ceil(total) : 1}
      rowsPerPage={perPage}
      page={page}
      SelectProps={{
        inputProps: { 'aria-label': 'rows per page' },
        native: true,
      }}
      onPageChange={onPageChange}
      onRowsPerPageChange={onChangeRowsPerPage}
    />
  );
}
